import { render, staticRenderFns } from "./sku-edit.vue?vue&type=template&id=5cba9895&scoped=true&"
import script from "./sku-edit.vue?vue&type=script&lang=js&"
export * from "./sku-edit.vue?vue&type=script&lang=js&"
import style0 from "./sku-edit.vue?vue&type=style&index=0&id=5cba9895&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba9895",
  null
  
)

export default component.exports